__turbopack_context__.v({
  "header": "Header-module__XHg4_a__header",
  "headerLogo": "Header-module__XHg4_a__headerLogo",
  "header__aiButton": "Header-module__XHg4_a__header__aiButton",
  "header__aiButtonActive": "Header-module__XHg4_a__header__aiButtonActive",
  "mobileMessageButton": "Header-module__XHg4_a__mobileMessageButton",
});
